(function() { window.GUID_1a7eba34_3a9b_4df6_90bf_69fcc385a1b0 = { getGuid: function() { return "1a7eba34-3a9b-4df6-90bf-69fcc385a1b0"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class EventPicker extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.controlId}`);
            }
            OnControlInstantiation(params) {
                var _a, _b, _c;
                this.controlId = params[0];
                this.preventRedirect = ((_a = params[1]) !== null && _a !== void 0 ? _a : "False") === "True";
                this.personaIds = (_b = params[2]) !== null && _b !== void 0 ? _b : "";
                this.onlyFrozenCsr = ((_c = params[3]) !== null && _c !== void 0 ? _c : "False") === "True";
            }
            OnBindEvents() {
                this.$Control.offon(`click.${this.ControlId}`, (e) => {
                    this.handlePickerClick(e);
                });
            }
            OnDispose() { }
            OnControlRendered() {
                const $returnUrlHiddenInput = this.$Control.find(`#${this.ControlId}-ReturnUrl`);
                if ($returnUrlHiddenInput.length) {
                    this.returnUrl = $returnUrlHiddenInput.val();
                }
                else {
                    this.returnUrl = "";
                }
            }
            handlePickerClick(e) {
                try {
                    const url = CS.Url.CSUrl("EventPickerDrawer");
                    if (CS.Helper.isNullOrWhiteSpace(url)) {
                        throw new Error("Url is null or empty");
                    }
                    Controls.Popup.ShowAjaxModal(url, {
                        personaIds: this.personaIds,
                        onlyFrozenCsr: this.onlyFrozenCsr,
                    }, ({ popup, isPopup }) => {
                        if (isPopup) {
                            if (popup.$Control) {
                                popup.$Control.offon("click.eventPickerItemClick", ".list-item", (e) => {
                                    this.handleItemClick(e);
                                });
                            }
                        }
                        CS.Controls.DropDown.Events.ListItemClicked({
                            selector: "body",
                            childSelector: "#dropdown-autocomplete-find-events-event-drpdwn-event-picker",
                            callback: (list, e) => {
                                var _a;
                                try {
                                    const _eventId = e.data.value;
                                    if (!_eventId || isNaN(_eventId)) {
                                        throw new Error("EventId is null or empty");
                                    }
                                    const eventId = Number(_eventId);
                                    let url = e.data.extraValues.CustomUrl;
                                    if (CS.Helper.isNullOrWhiteSpace(url)) {
                                        url = (_a = e.data.extraValues.Url) !== null && _a !== void 0 ? _a : "";
                                    }
                                    this.handleAutocompleteListItemClick(eventId, url);
                                }
                                catch (error) {
                                    console.error("Error while handling autocomplete list item click", error);
                                }
                            },
                        });
                    }, (p) => { }, true, false, true);
                }
                catch (error) {
                    console.error("Error while handling picker click", error);
                }
            }
            handleItemClick(e) {
                try {
                    const $item = $(e.currentTarget);
                    const _eventId = $item.data("value");
                    if (!_eventId || isNaN(_eventId)) {
                        throw new Error("EventId is null or empty");
                    }
                    const eventId = Number(_eventId);
                    if (this.preventRedirect) {
                        this.Trigger(EventPicker.EventNames.ItemClicked, {
                            jqueryEventObject: e,
                            data: {
                                eventId: eventId,
                            },
                        });
                        return;
                    }
                    if (!CS.Helper.isNullOrWhiteSpace(this.returnUrl)) {
                        this.navigateToReturnUrl(eventId);
                    }
                    else {
                        const href = $item.attr("href");
                        if (CS.Helper.isNullOrWhiteSpace(href)) {
                            return;
                        }
                        CS.Nav.Go(href);
                    }
                }
                catch (error) {
                    console.error("Error while handling event picker item click", error);
                }
            }
            handleAutocompleteListItemClick(eventId, url) {
                try {
                    if (this.preventRedirect) {
                        this.Trigger(EventPicker.EventNames.ItemClicked, {
                            jqueryEventObject: null,
                            data: {
                                eventId: eventId,
                            },
                        });
                        return;
                    }
                    if (!CS.Helper.isNullOrWhiteSpace(this.returnUrl)) {
                        this.navigateToReturnUrl(eventId);
                        return;
                    }
                    if (CS.Helper.isNullOrWhiteSpace(url)) {
                        throw new Error("Url is null or empty");
                    }
                    CS.Nav.Go(url);
                }
                catch (error) {
                    console.error("Error while handling autocomplete list item click", error);
                }
            }
            navigateToReturnUrl(eventId) {
                try {
                    let returnUrl = this.returnUrl;
                    const containsOrigin = returnUrl.indexOf(window.location.origin) > -1;
                    if (!containsOrigin) {
                        returnUrl = `${window.location.origin}${returnUrl}`;
                    }
                    const url = new URL(returnUrl);
                    const queryString = url.search;
                    const urlParams = new URLSearchParams(queryString);
                    const eventIdParam = urlParams.get("eventId");
                    const eventidParam = urlParams.get("eventid");
                    if (eventIdParam != null) {
                        urlParams.delete("eventId");
                    }
                    if (eventidParam != null) {
                        urlParams.delete("eventid");
                    }
                    urlParams.append("eventid", eventId.toString());
                    const newUrl = `${url.origin}${url.pathname}?${urlParams.toString()}`;
                    CS.Nav.Go(newUrl);
                }
                catch (error) {
                    console.error("Error while navigating to return url", error);
                }
            }
            Close() {
                try {
                    const $drawer = $(".event-picker-drawer");
                    if (!$drawer.length) {
                        return;
                    }
                    const popup = Controls.GetInstance(Controls.Popup, $drawer, true);
                    if (!popup) {
                        return;
                    }
                    popup.Close();
                }
                catch (error) {
                    console.error("Error while closing event picker", error);
                }
            }
        }
        Controls.EventPicker = EventPicker;
        (function (EventPicker) {
            class Events {
                static ItemClicked(param) {
                    Controls.RegisterEvent(EventPicker, EventNames.ItemClicked, param);
                }
            }
            EventPicker.Events = Events;
            class EventNames {
            }
            EventNames.ItemClicked = "event-picker-item-clicked";
            EventPicker.EventNames = EventNames;
        })(EventPicker = Controls.EventPicker || (Controls.EventPicker = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=event-picker.js.map
